import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { IntlProvider } from "react-intl";
import { useSelector } from "react-redux";
import messagesEn from "../../Languages/i18n.en.json";
import messagesEs from "../../Languages/i18n.es.json";
import { manageLocaleSelector } from "../../Selectors/LocaleSelector";
import App from "../App";
import ErrorBoundaryStrategy from "./ErrorBoundaryStrategy";

/**
 * @description Intl provider page of the App, provides intl, localization provider and error boundary wrapping
 * @returns {ReactNode} Renders the child nodes wrapped in intl, localization provider and error boundary.
 */

const AppIntl = () => {
  const { language } = useSelector((state) => manageLocaleSelector(state));
  const messages = {
    en: messagesEn,
    es: messagesEs,
  };

  return (
    <IntlProvider locale={language} messages={messages[language]}>
      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <ErrorBoundaryStrategy>
          <App />
        </ErrorBoundaryStrategy>
      </LocalizationProvider>
    </IntlProvider>
  );
};

export default AppIntl;
